<div fxLayout="column" class="page-container">
  <div fxLayout="column" class="eon-backdrop" fxLayoutAlign="center center">
    <div class="content-container" fxLayoutAlign="center center" fxLayout="column">
      <h1 class="splash-headline" fxLayoutAlign="center center">Miscellaneous Settings</h1>


        <div class="full-width">
          <form [formGroup]="rewardMessageFormGroup" class="full-width">
            <h2>Reward Message Setting</h2>
            <div fxLayout="row" class="full-width" fxLayoutGap="5px">
                <eon-ui-input formControlName="rewardMessageInput" placeholder="Enter the Reward Message here" fxFlex="80"></eon-ui-input>
                <eon-ui-button  fullWidth=true text="save"  type=text (click)="updateRewardMessage()" scheme="white" fxFlex="20"></eon-ui-button>
            </div>
          </form>
          <form [formGroup]="usernameMessageFormGroup" class="full-width">
            <h2>Sign up Message Setting</h2>
            <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center">
              <p>Message Disabled</p>
              <mat-slide-toggle scheme="white" formControlName="usernameMessageEnabledSlider" fxLayoutAlign="center"></mat-slide-toggle>
              <p>Message Enabled</p>
            </div>
            <div fxLayout="row" class="full-width" fxLayoutGap="5px">
              <eon-ui-input formControlName="usernameMessageInput" placeholder="Enter the Sign up Message here" fxFlex="80"></eon-ui-input>
              <eon-ui-button  fullWidth=true text="save"  type=text (click)="updateUsernameMessage()" scheme="white" fxFlex="20"></eon-ui-button>
            </div>
          </form>
          <eon-ui-divider></eon-ui-divider>
          <form [formGroup]="attemptsConfigFormGroup" class="full-width">
            <h2>Attempt Settings</h2>
            <div fxLayout="column" class="full-width">
              <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center">
                <p>Attempts Disabled</p>
                <mat-slide-toggle scheme="white" formControlName="attemptsEnabledSlider" fxLayoutAlign="center"></mat-slide-toggle>
                <p>Attempts Enabled</p>
              </div>
              <div fxLayout="row" fxLayoutGap="5px">
                <eon-ui-input formControlName="attemptCooldownInput" placeholder="Enter Attempt Cooldown in minutes" type="number" fxFlex="80"></eon-ui-input>
                <p fxFlex="20"> in Minutes</p>
              </div>
              <div>
                <eon-ui-button  fullWidth=true text="Save attempt settings"  type=text (click)="updateAttemptsConfig()" scheme="white"></eon-ui-button>
              </div>
            </div>
          </form>
        </div>

    </div>
  </div>
</div>
